import { useMemo } from 'react';
import { useIsSubdomain } from '../useIsSubdomain';
import { Booking, Course, Educator, Occurrence, Order } from '@shared/types';

type UseBookingOrOrderDetailsLinkProps = {
    courseSlug?: Course['slug'];
    educatorSlug?: Educator['slug'];
    occurrenceId: Occurrence['_id'] | null;
    recordId: Booking['_id'] | Order['_id'];
    recordType: 'booking' | 'order';
};

export const useBookingOrOrderDetailsLink = ({
    educatorSlug,
    courseSlug,
    occurrenceId,
    recordId,
    recordType,
}: UseBookingOrOrderDetailsLinkProps): string => {
    const urlDetails: string = useMemo(() => {
        if (recordType === 'booking') {
            if (occurrenceId) {
                return `details/${occurrenceId}?booking=${recordId}`;
            }
            return `dates?booking=${recordId}`;
        }
        return `details?orderId=${recordId}`;
    }, [occurrenceId, recordId, recordType]);

    const isSubdomain = useIsSubdomain();

    if (!educatorSlug || !courseSlug) {
        return '/';
    }
    if (isSubdomain) {
        return `/${courseSlug}/${urlDetails}`;
    }
    return `/${educatorSlug}/${courseSlug}/${urlDetails}`;
};
